'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Checkbox = require('../../01.atoms/Checkbox/Checkbox.js');
var LoaderContent = require('../../01.atoms/LoaderContent/LoaderContent.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Form = require('../Form/Form.js');
var Modal = require('../Modal/Modal.js');
var Input = require('../Input/Input.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-newsletter';
var cnNoPadding = "".concat(CLASSNAME, "--no-padding");
var cnWrapperInput = "".concat(CLASSNAME, "__wrapper-input");
var cnTitle = "".concat(CLASSNAME, "__title");
var cnInput = "".concat(CLASSNAME, "__input");
var cnButton = "".concat(CLASSNAME, "__button");
var cnModal = "".concat(CLASSNAME, "__modal");
var cnCheckbox = "".concat(CLASSNAME, "__checkbox");
var cnModalButton = "".concat(cnModal, "__button");
var cnModalButtons = "".concat(cnModal, "__buttons");
var cnRow = "".concat(CLASSNAME, "__row");
var cnRowReverse = "".concat(cnRow, " ").concat(cnRow, "--reverse");
var cnCol = "".concat(CLASSNAME, "__col");
/*************/

function TeaserNewsletter(_ref) {
  var _i18n$productRanges, _i18n$productRanges2, _i18n$interestItems;

  var className = _ref.className,
      i18n = _ref.i18n,
      locale = _ref.locale,
      data = _ref.data,
      inputName = _ref.inputName,
      mobile = _ref.mobile,
      onSignUp = _ref.onSignUp,
      noPadding = _ref.noPadding;

  var _useState = React.useState(),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      showLoader = _useState2[0],
      setShowLoader = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      modalVisible = _useState4[0],
      setModalVisible = _useState4[1];

  var _useState5 = React.useState(),
      _useState6 = _rollupPluginBabelHelpers.slicedToArray(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var onSignUpSuccess = function onSignUpSuccess() {
    setShowLoader(false);
    setModalVisible(true);
  };

  var productsOnlyModal = locale === 'ro-RO';
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnNoPadding, noPadding))
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: cnTitle
  }, i18n.headline), /*#__PURE__*/React__default.createElement("p", null, i18n.content), /*#__PURE__*/React__default.createElement(Form, {
    className: cnWrapperInput,
    onSubmitSuccess: function onSubmitSuccess(e) {
      setShowLoader(true);
      onSignUp(e, onSignUpSuccess);
    }
  }, !productsOnlyModal && /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, (_i18n$productRanges = i18n.productRanges) === null || _i18n$productRanges === void 0 ? void 0 : _i18n$productRanges.map(function (range) {
    var _data$products;

    return /*#__PURE__*/React__default.createElement("div", {
      key: range.key,
      className: cnCheckbox
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      label: range.value,
      name: "products[]",
      value: range.key,
      defaultChecked: (_data$products = data.products) === null || _data$products === void 0 ? void 0 : _data$products.includes(range.key)
    }));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement(Input, {
    required: true,
    validator: /.+@.+\..+/,
    type: "email",
    name: inputName,
    title: i18n.inputLabel,
    placeholder: i18n.inputPlaceholder,
    className: cnInput,
    value: data[inputName],
    onChange: function onChange(val) {
      return setEmail(val);
    },
    errorTitle: i18n.emailError,
    disabled: !!data[inputName]
  }), mobile && /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    description: i18n.privacyPolicy,
    name: "privacy",
    type: "checkbox",
    required: true
  })), /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.buttonLabel,
    className: cnButton,
    submit: true
  })), !mobile && /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    description: i18n.privacyPolicy,
    name: "privacy",
    type: "checkbox",
    required: true
  })), /*#__PURE__*/React__default.createElement("div", null)), /*#__PURE__*/React__default.createElement(Modal, {
    open: modalVisible,
    onClose: function onClose() {
      return setModalVisible(false);
    },
    title: i18n.modalTitle,
    className: cnModal,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(Form, {
    onSubmitSuccess: function onSubmitSuccess(formData) {
      setShowLoader(true);
      onSignUp(formData, function () {
        setShowLoader(false);
        setModalVisible(false);
      });
    }
  }, /*#__PURE__*/React__default.createElement(Input, {
    hidden: true,
    type: "email",
    name: inputName,
    title: i18n.inputLabel,
    placeholder: i18n.inputPlaceholder,
    className: cnInput,
    value: email || data[inputName]
  }), /*#__PURE__*/React__default.createElement(RichText, {
    content: i18n.modalContent
  }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Checkbox, {
    optionalLabel: i18n.optionalLabel,
    title: i18n.salutation,
    name: "salutation",
    type: "radio",
    items: [{
      value: 'Ms.',
      label: i18n.ms,
      defaultChecked: data.salutation === 'Ms.'
    }, {
      value: 'Mr.',
      label: i18n.mr,
      defaultChecked: data.salutation === 'Mr.'
    }]
  }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnCol
  }, /*#__PURE__*/React__default.createElement(Input, {
    title: i18n.firstName,
    optionalLabel: i18n.optionalLabel,
    name: "firstName",
    errorTitle: "",
    value: data.firstName
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cnCol
  }, /*#__PURE__*/React__default.createElement(Input, {
    title: i18n.lastName,
    optionalLabel: i18n.optionalLabel,
    name: "lastName",
    errorTitle: "",
    value: data.lastName
  }))), productsOnlyModal && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h4", null, i18n.productRange), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, (_i18n$productRanges2 = i18n.productRanges) === null || _i18n$productRanges2 === void 0 ? void 0 : _i18n$productRanges2.map(function (range) {
    var _data$products2;

    return /*#__PURE__*/React__default.createElement("div", {
      key: range.key,
      className: cnCol
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      label: range.value,
      name: "products[]",
      value: range.key,
      defaultChecked: (_data$products2 = data.products) === null || _data$products2 === void 0 ? void 0 : _data$products2.includes(range.key)
    }));
  }))), /*#__PURE__*/React__default.createElement("h4", null, i18n.interests), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, (_i18n$interestItems = i18n.interestItems) === null || _i18n$interestItems === void 0 ? void 0 : _i18n$interestItems.map(function (range) {
    var _data$interests;

    return /*#__PURE__*/React__default.createElement("div", {
      key: range.key,
      className: cnCol
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      label: range.value,
      name: "interests[]",
      value: range.key,
      defaultChecked: (_data$interests = data.interests) === null || _data$interests === void 0 ? void 0 : _data$interests.includes(range.key)
    }));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnRowReverse, cnModalButtons)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnCol
  }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.save,
    submit: true,
    className: cnModalButton
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cnCol
  }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.cancel,
    onClick: function onClick() {
      return setModalVisible(false);
    },
    type: "secondary",
    className: cnModalButton
  }))))), showLoader && /*#__PURE__*/React__default.createElement(LoaderContent, {
    fullscreen: true
  }));
}
TeaserNewsletter.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Data object */
  data: PropTypes.shape(),

  /** Translation object */
  i18n: PropTypes.shape().isRequired,

  /** Name of input for form */
  inputName: PropTypes.string,

  /** Currently selected language */
  locale: PropTypes.string,

  /** True for mobile styling */
  mobile: PropTypes.bool,

  /** True for no padding */
  noPadding: PropTypes.bool,

  /** Callback function */
  onSignUp: PropTypes.func.isRequired
};
TeaserNewsletter.defaultProps = {
  data: {},
  i18n: {},
  inputName: 'emailAddress',
  locale: 'en',
  mobile: false
};

module.exports = TeaserNewsletter;
